import type { PlanHorizon } from '@/api/generated/model';

export const PLAN_TIME_RANGES = [1, 5, 10, 20, 30] as const;
export type PlanTimeRange = (typeof PLAN_TIME_RANGES)[number];

export const PLAN_TIME_INCREMENTS = ['1M', '6M', '1Y', '5Y'] as const;
export type PlanTimeIncrement = (typeof PLAN_TIME_INCREMENTS)[number];

export interface PlanningTimePeriod {
  rangeYears: PlanTimeRange;
  increment: PlanTimeIncrement;
}

export const DEFAULT_PLANNING_TIME_PERIOD: PlanningTimePeriod = {
  rangeYears: 10,
  increment: '1Y',
};

/** Net worth breakdown table always shows today plus this many future years. */
export const NET_WORTH_TABLE_YEARS = 5;

export function horizonToTimePeriod(horizon: PlanHorizon): PlanningTimePeriod {
  return horizon === 'oneYear'
    ? { rangeYears: 1, increment: '1Y' }
    : { rangeYears: 10, increment: '1Y' };
}

export function formatTimePeriodTriggerLabel(period: PlanningTimePeriod): string {
  return `Today → ${period.rangeYears}Y | ${period.increment}`;
}

export function getProjectionYearsForRange(rangeYears: number): number[] {
  const startYear = new Date().getFullYear();
  return Array.from({ length: rangeYears }, (_, i) => startYear + i);
}

/** Thin chart/table columns based on increment (yearly data is always computed). */
export function filterYearsByIncrement(years: number[], increment: PlanTimeIncrement): number[] {
  switch (increment) {
    case '5Y':
      return years.filter((_, index) => index % 5 === 0 || index === years.length - 1);
    case '6M':
    case '1M':
      return years.length <= 1 ? years : [years[0], years[years.length - 1]];
    case '1Y':
    default:
      return years;
  }
}
